import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5ccff0ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "bg-white",
  id: "calendar-event"
}
const _hoisted_2 = {
  key: 0,
  class: "section h-full text-left"
}
const _hoisted_3 = { class: "font-bold" }
const _hoisted_4 = {
  key: 0,
  class: "special-toggle text-white bg-secondary-600 rounded-full px-2 py-1 w-40 right text-sm font-bold self-center text-center"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "event-dates flex" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-grow" }, null, -1))
const _hoisted_8 = {
  key: 2,
  class: "description-title text-primary-900 font-bold"
}
const _hoisted_9 = { class: "font-bold text-gray-600" }
const _hoisted_10 = { class: "details-scrollable h-96 overflow-y-scroll custom-scrollbar overflow-x-hidden" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = {
  key: 0,
  class: "recipients-title text-primary-900 font-bold sticky top-0 bg-white pt-4"
}
const _hoisted_14 = { class: "recipients" }
const _hoisted_15 = { class: "seen-marker col-span-1 self-center" }
const _hoisted_16 = {
  class: "m-auto",
  width: "11",
  height: "10",
  viewBox: "0 0 11 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_17 = ["fill"]
const _hoisted_18 = { class: "col-span-11 font-bold" }
const _hoisted_19 = {
  key: 2,
  class: "description-title text-primary-900 font-bold sticky top-0 bg-white pt-4"
}
const _hoisted_20 = { class: "description mr-1" }
const _hoisted_21 = { class: "actions block w-full text-center bg-white pb-6 absolute bottom-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SecondaryButton = _resolveComponent("SecondaryButton")!
  const _component_GMapMarker = _resolveComponent("GMapMarker")!
  const _component_GMapMap = _resolveComponent("GMapMap")!
  const _component_AddEditEventModalDialog = _resolveComponent("AddEditEventModalDialog")!
  const _component_DeleteEventDialog = _resolveComponent("DeleteEventDialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.event)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.event.title), 1),
          (_ctx.event.isGlobal)
            ? (_openBlock(), _createElementBlock("h2", _hoisted_4, "Evento globale"))
            : (_openBlock(), _createElementBlock("span", _hoisted_5)),
          _createElementVNode("div", _hoisted_6, [
            (_ctx.event.startTs)
              ? (_openBlock(), _createBlock(_component_SecondaryButton, {
                  key: 0,
                  class: "event-date text-primary block text-primary-600 bg-primary-50"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.moment.unix(_ctx.event.startTs).format('DD/MM/YY HH:mm')), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _hoisted_7,
            (_ctx.event.endTs)
              ? (_openBlock(), _createBlock(_component_SecondaryButton, {
                  key: 1,
                  class: "event-date text-primary block text-primary-600 bg-primary-50"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.moment.unix(_ctx.event.endTs).format('DD/MM/YY HH:mm')), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          (_ctx.event.address && _ctx.event.address.address)
            ? (_openBlock(), _createElementBlock("h2", _hoisted_8, "Indirizzo"))
            : _createCommentVNode("", true),
          (_ctx.event.address && _ctx.event.address.address)
            ? (_openBlock(), _createElementBlock("div", {
                key: 3,
                class: "place cursor-pointer",
                onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onMapClick && _ctx.onMapClick(...args)), ["stop","prevent"]))
              }, [
                (_ctx.event.address.lat != undefined && _ctx.event.address.lng != undefined)
                  ? (_openBlock(), _createBlock(_component_GMapMap, {
                      key: 0,
                      class: "map",
                      center: { lat: _ctx.event.address.lat, lng: _ctx.event.address.lng },
                      zoom: 7,
                      "map-type-id": "roadmap",
                      options: _ctx.mapOptions,
                      style: {"width":"100%","height":"400px"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_GMapMarker, {
                          position: { lat: _ctx.event.address.lat, lng: _ctx.event.address.lng },
                          clickable: false,
                          draggable: false,
                          icon: { url: '/marker-icon.png', scaledSize: {width: 30, height: 46}, labelOrigin: {x: 15, y: 0} }
                        }, null, 8, ["position", "icon"])
                      ]),
                      _: 1
                    }, 8, ["center", "options"]))
                  : _createCommentVNode("", true),
                _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.event.address.address), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_10, [
            (_ctx.event.isGlobal)
              ? (_openBlock(), _createElementBlock("span", _hoisted_11))
              : (_openBlock(), _createElementBlock("span", _hoisted_12, [
                  (_ctx.recipients.length > 0)
                    ? (_openBlock(), _createElementBlock("h3", _hoisted_13, " Persone a cui è assegnato"))
                    : _createCommentVNode("", true),
                  _createElementVNode("ul", _hoisted_14, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recipients, (recipient) => {
                      return (_openBlock(), _createElementBlock("li", {
                        class: "grid grid-cols-12",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToUser()))
                      }, [
                        _createElementVNode("div", _hoisted_15, [
                          (_openBlock(), _createElementBlock("svg", _hoisted_16, [
                            _createElementVNode("circle", {
                              cx: "5.42578",
                              cy: "5",
                              r: "5",
                              fill: _ctx.userHasCheckedEvent(recipient.id) ? 'var(--color-green-600)' : 'var(--color-red-600)'
                            }, null, 8, _hoisted_17)
                          ]))
                        ]),
                        _createElementVNode("div", _hoisted_18, _toDisplayString(recipient.surname) + " " + _toDisplayString(recipient.name), 1)
                      ]))
                    }), 256))
                  ])
                ])),
            (_ctx.event.description && _ctx.event.description.length > 0)
              ? (_openBlock(), _createElementBlock("h3", _hoisted_19, "Descrizione"))
              : _createCommentVNode("", true),
            _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.event.description), 1),
            _createElementVNode("div", _hoisted_21, [
              _createVNode(_component_SecondaryButton, {
                class: "block text-primary block bg-primary-100 text-primary-900",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.editEventDialog()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Modifica")
                ]),
                _: 1
              }),
              _createVNode(_component_SecondaryButton, {
                class: "block text-primary block bg-red-100 text-red-900",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.deleteEventDialog()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Elimina")
                ]),
                _: 1
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.editEvent)
      ? (_openBlock(), _createBlock(_component_AddEditEventModalDialog, {
          key: 1,
          onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.hideEditEventDialog())),
          event: _ctx.event,
          modelValue: _ctx.event,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.event) = $event))
        }, null, 8, ["event", "modelValue"]))
      : _createCommentVNode("", true),
    (_ctx.deleteEventIsShown)
      ? (_openBlock(), _createBlock(_component_DeleteEventDialog, {
          key: 2,
          onClose: _cache[6] || (_cache[6] = ($event: any) => (_ctx.hideDeleteEventDialog())),
          event: _ctx.event,
          modelValue: _ctx.event.id
        }, null, 8, ["event", "modelValue"]))
      : _createCommentVNode("", true)
  ]))
}